// eslint-disable-next-line no-unused-vars
var movesIta = {
    "1": "Botta",
    "2": "Colpokarate",
    "3": "Doppiasberla",
    "4": "Cometapugno",
    "5": "Megapugno",
    "6": "Giornopaga",
    "7": "Fuocopugno",
    "8": "Gelopugno",
    "9": "Tuonopugno",
    "10": "Graffio",
    "11": "Presa",
    "12": "Ghigliottina",
    "13": "Ventagliente",
    "14": "Danzaspada",
    "15": "Taglio",
    "16": "Raffica",
    "17": "Attacco d'Ala",
    "18": "Turbine",
    "19": "Volo",
    "20": "Legatutto",
    "21": "Schianto",
    "22": "Frustata",
    "23": "Pestone",
    "24": "Doppiocalcio",
    "25": "Megacalcio",
    "26": "Calciosalto",
    "27": "Calciorullo",
    "28": "Turbosabbia",
    "29": "Bottintesta",
    "30": "Incornata",
    "31": "Furia",
    "32": "Perforcorno",
    "33": "Azione",
    "34": "Corposcontro",
    "35": "Avvolgibotta",
    "36": "Riduttore",
    "37": "Colpo",
    "38": "Sdoppiatore",
    "39": "Colpocoda",
    "40": "Velenospina",
    "41": "Doppio Ago",
    "42": "Missilspillo",
    "43": "Fulmisguardo",
    "44": "Morso",
    "45": "Ruggito",
    "46": "Boato",
    "47": "Canto",
    "48": "Supersuono",
    "49": "Sonicboom",
    "50": "Inibitore",
    "51": "Acido",
    "52": "Braciere",
    "53": "Lanciafiamme",
    "54": "Nebbia",
    "55": "Pistolacqua",
    "56": "Idropompa",
    "57": "Surf",
    "58": "Geloraggio",
    "59": "Bora",
    "60": "Psicoraggio",
    "61": "Bollaraggio",
    "62": "Raggiaurora",
    "63": "Iper Raggio",
    "64": "Beccata",
    "65": "Perforbecco",
    "66": "Sottomissione",
    "67": "Colpo Basso",
    "68": "Contrattacco",
    "69": "Movim. Sismico",
    "70": "Forza",
    "71": "Assorbimento",
    "72": "Megassorbimento",
    "73": "Parassiseme",
    "74": "Crescita",
    "75": "Foglielama",
    "76": "Solarraggio",
    "77": "Velenpolvere",
    "78": "Paralizzante",
    "79": "Sonnifero",
    "80": "Petalodanza",
    "81": "Millebave",
    "82": "Ira di Drago",
    "83": "Turbofuoco",
    "84": "Tuonoshock",
    "85": "Fulmine",
    "86": "Tuononda",
    "87": "Tuono",
    "88": "Sassata",
    "89": "Terremoto",
    "90": "Abisso",
    "91": "Fossa",
    "92": "Tossina",
    "93": "Confusione",
    "94": "Psichico",
    "95": "Ipnosi",
    "96": "Meditazione",
    "97": "Agilit\u00e0",
    "98": "Attacco Rapido",
    "99": "Ira",
    "100": "Teletrasporto",
    "101": "Ombra Notturna",
    "102": "Mimica",
    "103": "Stridio",
    "104": "Doppioteam",
    "105": "Ripresa",
    "106": "Rafforzatore",
    "107": "Minimizzato",
    "108": "Muro di Fumo",
    "109": "Stordiraggio",
    "110": "Ritirata",
    "111": "Ricciolscudo",
    "112": "Barriera",
    "113": "Schermoluce",
    "114": "Nube",
    "115": "Riflesso",
    "116": "Focalenergia",
    "117": "Pazienza",
    "118": "Metronomo",
    "119": "Speculmossa",
    "120": "Autodistruzione",
    "121": "Uovobomba",
    "122": "Leccata",
    "123": "Smog",
    "124": "Fango",
    "125": "Ossoclava",
    "126": "Fuocobomba",
    "127": "Cascata",
    "128": "Tenaglia",
    "129": "Comete",
    "130": "Capocciata",
    "131": "Sparalance",
    "132": "Limitazione",
    "133": "Amnesia",
    "134": "Cin\u00e8si",
    "135": "Covauova",
    "136": "Calcinvolo",
    "137": "Sguardo Feroce",
    "138": "Mangiasogni",
    "139": "Velenogas",
    "140": "Sferattacco",
    "141": "Sanguisuga",
    "142": "Demonbacio",
    "143": "Aeroattacco",
    "144": "Trasformazione",
    "145": "Bolla",
    "146": "Stordipugno",
    "147": "Spora",
    "148": "Flash",
    "149": "Psiconda",
    "150": "Splash",
    "151": "Scudo Acido",
    "152": "Martellata",
    "153": "Esplosione",
    "154": "Sfuriate",
    "155": "Ossomerang",
    "156": "Riposo",
    "157": "Frana",
    "158": "Iperzanna",
    "159": "Affilatore",
    "160": "Conversione",
    "161": "Tripletta",
    "162": "Superzanna",
    "163": "Lacerazione",
    "164": "Sostituto",
    "165": "Scontro",
    "166": "Schizzo",
    "167": "Triplocalcio",
    "168": "Furto",
    "169": "Ragnatela",
    "170": "Leggimente",
    "171": "Incubo",
    "172": "Ruotafuoco",
    "173": "Russare",
    "174": "Maledizione",
    "175": "Flagello",
    "176": "Conversione2",
    "177": "Aerocolpo",
    "178": "Cotonspora",
    "179": "Contropiede",
    "180": "Dispetto",
    "181": "Polneve",
    "182": "Protezione",
    "183": "Pugnorapido",
    "184": "Visotruce",
    "185": "Finta",
    "186": "Dolcebacio",
    "187": "Panciamburo",
    "188": "Fangobomba",
    "189": "Fangosberla",
    "190": "Octazooka",
    "191": "Punte",
    "192": "Elettrocannone",
    "193": "Preveggenza",
    "194": "Destinobbligato",
    "195": "Ultimocanto",
    "196": "Ventogelato",
    "197": "Individua",
    "198": "Ossoraffica",
    "199": "Localizza",
    "200": "Oltraggio",
    "201": "Terrempesta",
    "202": "Gigassorbimento",
    "203": "Resistenza",
    "204": "Fascino",
    "205": "Rotolamento",
    "206": "Falsofinale",
    "207": "Bullo",
    "208": "Buonlatte",
    "209": "Scintilla",
    "210": "Tagliofuria",
    "211": "Alacciaio",
    "212": "Malosguardo",
    "213": "Attrazione",
    "214": "Sonnolalia",
    "215": "Rintoccasana",
    "216": "Ritorno",
    "217": "Regalino",
    "218": "Frustrazione",
    "219": "Salvaguardia",
    "220": "Malcomune",
    "221": "Magifuoco",
    "222": "Magnitudo",
    "223": "Dinamipugno",
    "224": "Megacorno",
    "225": "Dragospiro",
    "226": "Staffetta",
    "227": "Ripeti",
    "228": "Inseguimento",
    "229": "Rapigiro",
    "230": "Profumino",
    "231": "Codacciaio",
    "232": "Ferrartigli",
    "233": "Vitaltiro",
    "234": "Mattindoro",
    "235": "Sintesi",
    "236": "Lucelunare",
    "237": "Introforza",
    "238": "Incrocolpo",
    "239": "Tornado",
    "240": "Pioggiadanza",
    "241": "Giornodisole",
    "242": "Sgranocchio",
    "243": "Specchiovelo",
    "244": "Psicamis\u00f9",
    "245": "Extrarapido",
    "246": "Forzantica",
    "247": "Palla Ombra",
    "248": "Divinazione",
    "249": "Spaccaroccia",
    "250": "Mulinello",
    "251": "Picchiaduro",
    "252": "Bruciapelo",
    "253": "Baraonda",
    "254": "Accumulo",
    "255": "Sfoghenergia",
    "256": "Introenergia",
    "257": "Ondacalda",
    "258": "Grandine",
    "259": "Attaccalite",
    "260": "Adulazione",
    "261": "Fuocofatuo",
    "262": "Memento",
    "263": "Facciata",
    "264": "Centripugno",
    "265": "Maniereforti",
    "266": "Sonoqui",
    "267": "Naturforza",
    "268": "Sottocarica",
    "269": "Provocazione",
    "270": "Altruismo",
    "271": "Raggiro",
    "272": "Giocodiruolo",
    "273": "Desiderio",
    "274": "Assistente",
    "275": "Radicamento",
    "276": "Troppoforte",
    "277": "Magivelo",
    "278": "Riciclo",
    "279": "Vendetta",
    "280": "Breccia",
    "281": "Sbadiglio",
    "282": "Privazione",
    "283": "Rimonta",
    "284": "Eruzione",
    "285": "Baratto",
    "286": "Esclusiva",
    "287": "Rinfrescata",
    "288": "Rancore",
    "289": "Scippo",
    "290": "Forzasegreta",
    "291": "Sub",
    "292": "Sberletese",
    "293": "Camuffamento",
    "294": "Codadiluce",
    "295": "Abbagliante",
    "296": "Foschisfera",
    "297": "Danzadipiume",
    "298": "Strampadanza",
    "299": "Calciardente",
    "300": "Fangata",
    "301": "Palla Gelo",
    "302": "Pugnospine",
    "303": "Pigro",
    "304": "Granvoce",
    "305": "Velenodenti",
    "306": "Tritartigli",
    "307": "Incendio",
    "308": "Idrocannone",
    "309": "Meteorpugno",
    "310": "Sgomento",
    "311": "Palla Clima",
    "312": "Aromaterapia",
    "313": "Falselacrime",
    "314": "Aerasoio",
    "315": "Vampata",
    "316": "Segugio",
    "317": "Rocciotomba",
    "318": "Ventargenteo",
    "319": "Ferrostrido",
    "320": "Meloderba",
    "321": "Solletico",
    "322": "Cosmoforza",
    "323": "Zampillo",
    "324": "Segnoraggio",
    "325": "Pugnodombra",
    "326": "Extrasenso",
    "327": "Stramontante",
    "328": "Sabbiotomba",
    "329": "Purogelo",
    "330": "Fanghiglia",
    "331": "Semitraglia",
    "332": "Aeroassalto",
    "333": "Gelolancia",
    "334": "Ferroscudo",
    "335": "Blocco",
    "336": "Gridodilotta",
    "337": "Dragartigli",
    "338": "Radicalbero",
    "339": "Granfisico",
    "340": "Rimbalzo",
    "341": "Colpodifango",
    "342": "Velenocoda",
    "343": "Supplica",
    "344": "Locomovolt",
    "345": "Fogliamagica",
    "346": "Docciascudo",
    "347": "Calmamente",
    "348": "Fendifoglia",
    "349": "Dragodanza",
    "350": "Cadutamassi",
    "351": "Ondashock",
    "352": "Idropulsar",
    "353": "Desiderio Fatale",
    "354": "Psicoslancio",
    "355": "Trespolo",
    "356": "Gravit\u00e0",
    "357": "Miracolvista",
    "358": "Svegliopacca",
    "359": "Martelpugno",
    "360": "Vortexpalla",
    "361": "Curardore",
    "362": "Acquadisale",
    "363": "Dononaturale",
    "364": "Fintoattacco",
    "365": "Spennata",
    "366": "Ventoincoda",
    "367": "Acupressione",
    "368": "Metalscoppio",
    "369": "Retromarcia",
    "370": "Zuffa",
    "371": "Rivincita",
    "372": "Garanzia",
    "373": "Divieto",
    "374": "Lancio",
    "375": "Psicotransfer",
    "376": "Asso",
    "377": "Anticura",
    "378": "Strizzata",
    "379": "Ingannoforza",
    "380": "Gastroacido",
    "381": "Fortuncanto",
    "382": "Precedenza",
    "383": "Copione",
    "384": "Barattoforza",
    "385": "Barattoscudo",
    "386": "Punizione",
    "387": "Ultimascelta",
    "388": "Affannoseme",
    "389": "Sbigoattacco",
    "390": "Fielepunte",
    "391": "Cuorbaratto",
    "392": "Acquanello",
    "393": "Magnetascesa",
    "394": "Fuococarica",
    "395": "Palmoforza",
    "396": "Sferapulsar",
    "397": "Lucidatura",
    "398": "Velenpuntura",
    "399": "Neropulsar",
    "400": "Nottesferza",
    "401": "Idrondata",
    "402": "Semebomba",
    "403": "Eterelama",
    "404": "Forbice X",
    "405": "Ronzio",
    "406": "Dragopulsar",
    "407": "Dragofuria",
    "408": "Gemmoforza",
    "409": "Assorbipugno",
    "410": "Vuotonda",
    "411": "Focalcolpo",
    "412": "Energipalla",
    "413": "Baldeali",
    "414": "Geoforza",
    "415": "Rapidscambio",
    "416": "Gigaimpatto",
    "417": "Congiura",
    "418": "Pugnoscarica",
    "419": "Slavina",
    "420": "Geloscheggia",
    "421": "Ombrartigli",
    "422": "Fulmindenti",
    "423": "Gelodenti",
    "424": "Rogodenti",
    "425": "Furtivombra",
    "426": "Pantanobomba",
    "427": "Psicotaglio",
    "428": "Cozzata Zen",
    "429": "Cristalcolpo",
    "430": "Cannonflash",
    "431": "Scalaroccia",
    "432": "Scacciabruma",
    "433": "Distortozona",
    "434": "Dragobolide",
    "435": "Scarica",
    "436": "Lavasbuffo",
    "437": "Verdebufera",
    "438": "Vigorcolpo",
    "439": "Devastomasso",
    "440": "Velenocroce",
    "441": "Sporcolancio",
    "442": "Metaltestata",
    "443": "Bombagnete",
    "444": "Pietrataglio",
    "445": "Incanto",
    "446": "Levitoroccia",
    "447": "Laccioerboso",
    "448": "Schiamazzo",
    "449": "Giudizio",
    "450": "Coleomorso",
    "451": "Raggioscossa",
    "452": "Mazzuolegno",
    "453": "Acquagetto",
    "454": "Comandourto",
    "455": "Comandoscudo",
    "456": "Comandocura",
    "457": "Zuccata",
    "458": "Doppiosmash",
    "459": "Fragortempo",
    "460": "Fendispazio",
    "461": "Lunardanza",
    "462": "Sbriciolmano",
    "463": "Magmaclisma",
    "464": "Vuototetro",
    "465": "Infuriaseme",
    "466": "Funestovento",
    "467": "Oscurotuffo",
    "468": "Unghiaguzze",
    "469": "Bodyguard",
    "470": "Paridifesa",
    "471": "Pariattacco",
    "472": "Mirabilzona",
    "473": "Psicoshock",
    "474": "Velenoshock",
    "475": "Sganciapesi",
    "476": "Polverabbia",
    "477": "Telecinesi",
    "478": "Magicozona",
    "479": "Abbattimento",
    "480": "Tempestretta",
    "481": "Pirolancio",
    "482": "Fangonda",
    "483": "Eledanza",
    "484": "Pesobomba",
    "485": "Sincrumore",
    "486": "Energisfera",
    "487": "Inondazione",
    "488": "Nitrocarica",
    "489": "Arrotola",
    "490": "Calciobasso",
    "491": "Acidobomba",
    "492": "Ripicca",
    "493": "Ondisinvolta",
    "494": "Saltamicizia",
    "495": "Cortesia",
    "496": "Coro",
    "497": "Echeggiavoce",
    "498": "Insidia",
    "499": "Pulifumo",
    "500": "Veicolaforza",
    "501": "Anticipo",
    "502": "Cambiaposto",
    "503": "Idrovampata",
    "504": "Gettaguscio",
    "505": "Curapulsar",
    "506": "Sciagura",
    "507": "Cadutalibera",
    "508": "Cambiomarcia",
    "509": "Ribaltiro",
    "510": "Bruciatutto",
    "511": "Spintone",
    "512": "Acrobazia",
    "513": "Riflettipo",
    "514": "Nemesi",
    "515": "Azzardo",
    "516": "Cediregalo",
    "517": "Marchiatura",
    "518": "Acquapatto",
    "519": "Fiammapatto",
    "520": "Erbapatto",
    "521": "Invertivolt",
    "522": "Entomoblocco",
    "523": "Battiterra",
    "524": "Alitogelido",
    "525": "Codadrago",
    "526": "Cuordileone",
    "527": "Elettrotela",
    "528": "Sprizzalampo",
    "529": "Giravvita",
    "530": "Doppiocolpo",
    "531": "Cuorestampo",
    "532": "Legnicorno",
    "533": "Spadasolenne",
    "534": "Conchilama",
    "535": "Marchiafuoco",
    "536": "Vorticerba",
    "537": "Rulloduro",
    "538": "Cotonscudo",
    "539": "Urtoscuro",
    "540": "Psicobotta",
    "541": "Spazzasberla",
    "542": "Tifone",
    "543": "Ricciolata",
    "544": "Ingracolpo",
    "545": "Sparafuoco",
    "546": "Tecnobotto",
    "547": "Cantoantico",
    "548": "Spadamistica",
    "549": "Gelamondo",
    "550": "Lucesiluro",
    "551": "Fuocoblu",
    "552": "Voldifuoco",
    "553": "Elettrogelo",
    "554": "Vampagelida",
    "555": "Urlorabbia",
    "556": "Scagliagelo",
    "557": "Generatore V",
    "558": "Incrofiamma",
    "559": "Incrotuono",
    "560": "Schiacciatuffo",
    "561": "Ribaltappeto",
    "562": "Rutto",
    "563": "Aracampo",
    "564": "Rete Vischiosa",
    "565": "Pungiglione",
    "566": "Spettrotuffo",
    "567": "Halloween",
    "568": "Urlo",
    "569": "Pioggiaplasma",
    "570": "Caricaparabola",
    "571": "Boscomalocchio",
    "572": "Fiortempesta",
    "573": "Liofilizzazione",
    "574": "Incantavoce",
    "575": "Monito",
    "576": "Sottosopra",
    "577": "Assorbibacio",
    "578": "Truccodifesa",
    "579": "Fiordifesa",
    "580": "Campo Erboso",
    "581": "Campo Nebbioso",
    "582": "Elettrocontagio",
    "583": "Carineria",
    "584": "Vento di Fata",
    "585": "Forza Lunare",
    "586": "Ondaboato",
    "587": "Blocco Fatato",
    "588": "Scudo Reale",
    "589": "Simpatia",
    "590": "Confidenza",
    "591": "Diamantempesta",
    "592": "Vaporscoppio",
    "593": "Forodimensionale",
    "594": "Acqualame",
    "595": "Magifiamma",
    "596": "Agodifesa",
    "597": "Nebularoma",
    "598": "Elettromistero",
    "599": "Velenotrappola",
    "600": "Pulviscoppio",
    "601": "Geocontrollo",
    "602": "Controllo Polare",
    "603": "Cuccagna",
    "604": "Campo Elettrico",
    "605": "Magibrillio",
    "606": "Auguri",
    "607": "Mano nella Mano",
    "608": "Occhioni Teneri",
    "609": "Elettrococcola",
    "610": "Riguardo",
    "611": "Assillo",
    "612": "Crescipugno",
    "613": "Ali del Fato",
    "614": "Mille Frecce",
    "615": "Mille Onde",
    "616": "Forza Tellurica",
    "617": "Luce Nefasta",
    "618": "Primopulsar",
    "619": "Spade Telluriche",
    "620": "Ascesa del Drago",
    "621": "Urtodimensionale",
    "622": "Carica Travolgente",
    "623": "Carica Travolgente",
    "624": "Iperscarica Furiosa",
    "625": "Iperscarica Furiosa",
    "626": "Picchiata Devastante",
    "627": "Picchiata Devastante",
    "628": "Acidiluvio Corrosivo",
    "629": "Acidiluvio Corrosivo",
    "630": "Furore della Terra",
    "631": "Furore della Terra",
    "632": "Gigamacigno Polverizzante",
    "633": "Gigamacigno Polverizzante",
    "634": "Bozzolo Fatale",
    "635": "Bozzolo Fatale",
    "636": "Abbraccio Spettrale",
    "637": "Abbraccio Spettrale",
    "638": "Spirale Perforante",
    "639": "Spirale Perforante",
    "640": "Fiammobomba Detonante",
    "641": "Fiammobomba Detonante",
    "642": "Idrovortice Abissale",
    "643": "Idrovortice Abissale",
    "644": "Floriscoppio Sfolgorante",
    "645": "Floriscoppio Sfolgorante",
    "646": "Gigascarica Folgorante",
    "647": "Gigascarica Folgorante",
    "648": "Impatto Psicocinetico",
    "649": "Impatto Psicocinetico",
    "650": "Criodistruzione Polare",
    "651": "Criodistruzione Polare",
    "652": "Dragoschianto Finale",
    "653": "Dragoschianto Finale",
    "654": "Buco Nero del Non Ritorno",
    "655": "Buco Nero del Non Ritorno",
    "656": "Astroimpatto Fatato",
    "657": "Astroimpatto Fatato",
    "658": "Super Pikaboom",
    "659": "Sabbiaccumulo",
    "660": "Schermaglia",
    "661": "Fortino",
    "662": "Cucitura d'Ombra",
    "663": "Braccioteso",
    "664": "Canto Effimero",
    "665": "Martelgelo",
    "666": "Cura Floreale",
    "667": "Forza Equina",
    "668": "Assorbiforza",
    "669": "Lama Solare",
    "670": "Fogliame",
    "671": "Riflettore",
    "672": "Velenotela",
    "673": "Concentrazione",
    "674": "Marciainpi\u00f9",
    "675": "Colpo Infernale",
    "676": "Sferapolline",
    "677": "Colpo d'Ancora",
    "678": "Campo Psichico",
    "679": "Assalto",
    "680": "Frusta di Fuoco",
    "681": "Tracotanza",
    "682": "Ultima Fiamma",
    "683": "Velociscambio",
    "684": "Sottilcorno",
    "685": "Purificazione",
    "686": "Mutadanza",
    "687": "Nucleocastigo",
    "688": "Tropicalcio",
    "689": "Imposizione",
    "690": "Cannonbecco",
    "691": "Clamorsquame",
    "692": "Marteldrago",
    "693": "Vorticolpo",
    "694": "Velaurora",
    "695": "Dardoassalto Spettrale",
    "696": "Iperschianto delle Tenebre",
    "697": "Sinfonia del Mare",
    "698": "Collera del Guardiano",
    "699": "Colpo Eptastellare Rubanima",
    "700": "Elettrosurf Folgorante",
    "701": "Adesso Faccio sul Serio",
    "702": "Potenziamento Eevolutivo",
    "703": "Supernova delle Origini",
    "704": "Gusciotrappola",
    "705": "Cannonfiore",
    "706": "Psicozanna",
    "707": "Battipiedi",
    "708": "Ossotetro",
    "709": "Rocciarapida",
    "710": "Idrobreccia",
    "711": "Prismalaser",
    "712": "Ombrafurto",
    "713": "Astrocarica",
    "714": "Raggio d'Ombra",
    "715": "Occhionilucidi",
    "716": "Elettropizzico",
    "717": "Ira della Natura",
    "718": "Multiattacco",
    "719": "Iperfulmine",
    "720": "Sbalorditesta",
    "721": "Pugni Plasma",
    "722": "Geyser Fotonico",
    "723": "Fotodistruzione Apocalittica",
    "724": "Supercollisione Solare",
    "725": "Deflagrazione Lunare",
    "726": "Dolcesacco di Botte",
    "727": "Litotempesta Radiale",
    "728": "Dracofonia Divampante",
    "729": "Sprintaboom",
    "730": "Surfasplash",
    "731": "Piombaflap",
    "732": "Pikasaetta",
    "733": "Bollaslurp",
    "734": "Elettrozap",
    "735": "Fiammabam",
    "736": "Auraswoosh",
    "737": "Zona Buiabuia",
    "738": "Bombafrush",
    "739": "Scricchiagelo",
    "740": "Sbrilluccibufera",
    "741": "Eeveempatto",
    "742": "Pugni Corazzati",
    "743": "Dynabarriera",
    "744": "Cannone Dynamax",
    "745": "Tiromirato",
    "746": "Morsostretto",
    "747": "Riempiguance",
    "748": "Spalle al Muro",
    "749": "Colpocatrame",
    "750": "Magipolvere",
    "751": "Dragofrecce",
    "752": "Ora del T\u00e8",
    "753": "Tentacolock",
    "754": "Beccoshock",
    "755": "Branchiomorso",
    "756": "Cambiocampo",
    "757": "Dynafiammata",
    "758": "Dynainsetto",
    "759": "Dynasaetta",
    "760": "Dynattacco",
    "761": "Dynapugno",
    "762": "Dynavuoto",
    "763": "Dynagelo",
    "764": "Dynacorrosione",
    "765": "Dynaflusso",
    "766": "Dynajet",
    "767": "Dynafata",
    "768": "Dynadragone",
    "769": "Dynapsiche",
    "770": "Dynamacigno",
    "771": "Dynasisma",
    "772": "Dynatenebre",
    "773": "Dynaflora",
    "774": "Dynametallo",
    "775": "Dracofonia",
    "776": "Schiacciacorpo",
    "777": "Decorazione",
    "778": "Tamburattacco",
    "779": "Tagliola",
    "780": "Palla Infuocata",
    "781": "Taglio Maestoso",
    "782": "Colpo Maestoso",
    "783": "Ruota d'Aura",
    "784": "Vastoimpatto",
    "785": "Ramostoccata",
    "786": "Overdrive",
    "787": "Acido Malico",
    "788": "Forza G",
    "789": "Frantumanima",
    "790": "Vapore Incantato",
    "791": "Goccia Vitale",
    "792": "Sbarramento",
    "793": "Supplicolpo",
    "794": "Sfolgorassalto",
    "795": "Raggio Infinito",
    "796": "Raggio d'Acciaio",
    "797": "Vastenergia",
    "798": "Ferrorullo",
    "799": "Squamacolpo",
    "800": "Raggiometeora",
    "801": "Armaguscio",
    "802": "Nebbioscoppio",
    "803": "Erboscivolata",
    "804": "Elettroimpennata",
    "805": "Campopulsar",
    "806": "Strisciacolpo",
    "807": "Fiamminvidia",
    "808": "Sfogarabbia",
    "809": "Poltergeist",
    "810": "Gas Corrosivo",
    "811": "Coaching",
    "812": "Virata",
    "813": "Triplo Axel",
    "814": "Doppia Ala",
    "815": "Sabbiardente",
    "816": "Giunglacura",
    "817": "Pugnotenebra",
    "818": "Idroraffica",
    "819": "Elettrogabbia",
    "820": "Dragoenergia",
    "821": "Sguardo Gelido",
    "822": "Furia Ardente",
    "823": "Calcio Tonante",
    "824": "Lancia Glaciale",
    "825": "Schegge Astrali",
    "826": "Inquietantesimo",
    "827": "Artigli Fatali",
    "828": "Barrierassalto",
    "829": "Scambioforza",
    "830": "Rocciascure",
    "831": "Tempesta Zefirea",
    "832": "Forza Mistica",
    "833": "Ira Furente",
    "834": "Ondaschianto",
    "835": "Clorofillaser",
    "836": "Soffio d'Iceberg",
    "837": "Danzavittoria",
    "838": "Scontro Frontale",
    "839": "Mille Fielespine",
    "840": "Ali d'Aura",
    "841": "Livore",
    "842": "Barricata",
    "843": "Triplodardo",
    "844": "Corteo Spettrale",
    "845": "Lama Milleflutti",
    "846": "Tempesta Boreale",
    "847": "Tempesta Tonante",
    "848": "Tempesta Ardente",
    "849": "Invocaluna",
    "850": "Baldimpulso",
    "851": "Terascoppio",
    "852": "Telatrappola",
    "853": "Calcio ad Ascia",
    "854": "Omaggio ai KO",
    "855": "Fotocollisione",
    "856": "Alta Cucina",
    "857": "Pugnojet",
    "858": "Essenza Piccante",
    "859": "Slittaruote",
    "860": "Infestazione",
    "861": "Vortighiaccio",
    "862": "Spadoncarica",
    "863": "Preghiera Vitale",
    "864": "Sotto Sale",
    "865": "Triplo Tuffo",
    "866": "Glitturbine",
    "867": "Ricalco",
    "868": "Alleggerimento",
    "869": "Genufendente",
    "870": "Prestigiafiore",
    "871": "Canzone Ardente",
    "872": "Idroballetto",
    "873": "Scatenatoro",
    "874": "Corsa all'Oro",
    "875": "Psicolama",
    "876": "Idrovapore",
    "877": "Catastrofe",
    "878": "Turboschianto",
    "879": "Fulmiscatto",
    "880": "Tagliacoda",
    "881": "Freddura",
    "882": "Pulizie",
    "883": "Vista Innevata",
    "884": "Balzo",
    "885": "Apripista",
    "886": "Doccia Fredda",
    "887": "Ipertrapano",
    "888": "Doppioraggio",
    "889": "Pugno Furibondo",
    "890": "Corazza Cannone",
    "891": "Lama del Rimorso",
    "892": "Doppiolampo",
    "893": "Granmartello",
    "894": "Ritorsione",
    "895": "Idrotaglio",
    "896": "Turboustione",
    "897": "Turbotenebra",
    "898": "Turbotossina",
    "899": "Turborissa",
    "900": "Turboincanto",
    "901": "Luna Rossa",
    "902": "Spruzzat\u00e8",
    "903": "Bomba Sciroppata",
    "904": "Clava di Liane",
    "905": "Elettroraggio",
    "906": "Teracluster",
    "907": "Irregolaser",
    "908": "Egida Ignea",
    "909": "Saetta",
    "910": "Taglio Poderoso",
    "911": "Tachiontaglio",
    "912": "Pressa d'Acciaio",
    "913": "Grido del Drago",
    "914": "Ammaliavoce",
    "915": "Rabbia Bruciante",
    "916": "Elettrotuffo",
    "917": "Psicorumore",
    "918": "Colpo di Mano"
}
export default movesIta;